import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import CategoryForm from '../../../components/SiteAdmin/CategoryForm/CategoryForm';


export class AddTopFeature extends Component {

    render() {
        return (
            <CategoryForm />
        )
    }
}

const mapStateToProps = (state) => ({})
const mapDispatchToProps = {}

export default compose(
    injectIntl,
    connect(mapStateToProps, mapDispatchToProps)
)(AddTopFeature)
